export enum SupervisorTaskColumns {
  phase,
  name,
  description,
  remove,
}
